import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";

import BarraNavegacion from "Componentes/BarraNavegacion";

const Login = lazy(() => import("Login/Login"));
const ForgotPassword = lazy(() => import("Login/ForgotPassword"));
const ResetPassword = lazy(() => import("Login/ResetPassword"));

const ResponseSurvey = lazy(() => import("Surveys/ResponseSurvey"));
const CreateSurvey = lazy(() => import("Surveys/CreateSurvey"));
const EditSurvey = lazy(() => import("Surveys/EditSurvey"));
const ListSurveys = lazy(() => import("Surveys/ListSurveys"));
const GlobalStats = lazy(() => import("Surveys/GlobalStats"));
const Analytics = lazy(() => import("Surveys/Analytics"));
const ThankYou = lazy(() => import("Surveys/ThankYou"));
const FinUUID = lazy(() => import("Surveys/finUUID"));

const PoliticaCookies = lazy(() => import("PoliticaCookies/PoliticaCookies"));
const EmailLogs = lazy(() => import("EmailLogs/EmailLogs"));
const Templates = lazy(() => import("Templates/Templates"));
const Settings = lazy(() => import("Settings/Settings"));
const DemoRequest = lazy(() => import("DemoRequest/DemoRequest"));
const Companies = lazy(() => import("Companies/Companies"));

const PageLoader = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
    <CircularProgress />
  </Box>
);

// Componente de ruta protegida

const ProtectedRoute = ({ children }) => {

  const token = localStorage.getItem("tokenSurvey");

  const handleLogout = () => {
    localStorage.removeItem("tokenSurvey");
    window.location.href = "/login";
  };

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <BarraNavegacion onLogout={handleLogout} />
      <div style={{ marginTop: "20px" }}>{children}</div>
    </>
  );
};

const AppRoutes = () => {
  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
      <Routes>
        {/******************/}
        {/* RUTAS PUBLICAS */}
        {/******************/}

        <Route
          path="/"
          element={<Navigate to="/ListSurveys" replace />}
        />

        <Route
          path="/surveys"
          element={<Navigate to="/ListSurveys" replace />}
        />

        <Route
          path="/login"
          element={<Login />}
        />

        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />

        <Route
          path="/reset-password/:token"
          element={<ResetPassword />}
        />

        <Route
          path="/survey/:code"
          element={<ResponseSurvey />}
        />
        <Route
          path="/ThankYou/:code"
          element={<ThankYou />}
        />

        <Route
          path="/finUUID"
          element={<FinUUID />} />

        <Route
          path="/politicaCookies"
          element={<PoliticaCookies />}
        />

        <Route
          path="/DemoRequest"
          element={<DemoRequest />}
        />

        {/********************/}
        {/* RUTAS PROTEGIDAS */}
        {/********************/}

        <Route
          path="/ListSurveys"
          element={
            <ProtectedRoute>
              <ListSurveys />
            </ProtectedRoute>
          }
        />

        <Route
          path="/CreateSurvey"
          element={
            <ProtectedRoute>
              <CreateSurvey />
            </ProtectedRoute>
          }
        />

        <Route
          path="/surveys/edit/:id"
          element={
            <ProtectedRoute>
              <EditSurvey />
            </ProtectedRoute>
          }
        />

        <Route
          path="/surveys/:id/GlobalStats"
          element={
            <ProtectedRoute>
              <GlobalStats />
            </ProtectedRoute>
          }
        />

        <Route
          path="/surveys/:id/Analytics"
          element={
            <ProtectedRoute>
              <Analytics />
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />

        <Route
          path="/EmailLogs"
          element={
            <ProtectedRoute>
              <EmailLogs />
            </ProtectedRoute>
          }
        />

        <Route
          path="/templates"
          element={
            <ProtectedRoute>
              <Templates />
            </ProtectedRoute>
          }
        />

        <Route
          path="/companies"
          element={
            <ProtectedRoute>
              <Companies />
            </ProtectedRoute>
          }
        />

      </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRoutes;